import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css"; // CSS for navbar styles

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // Toggle state for mobile menu

  const toggleMenu = () => setIsOpen(!isOpen); // Function to toggle the mobile menu

  return (
    <nav className="navbar">
      {/* Logo with Link */}
      <div className="nav-brand-icon">
        <Link to="/">
          <img
            src="/img/logo-2.png"
            alt="Westfield Transport Ltd."
            className="nav-logo"
          />
        </Link>
      </div>

      {/* Navigation Links */}
      <div className={`nav-links ${isOpen ? "open" : ""}`}>
        <Link to="/" onClick={() => setIsOpen(false)}>
          Home
        </Link>
        <Link to="/contact" onClick={() => setIsOpen(false)}>
          Contact
        </Link>
        <Link to="/careers" onClick={() => setIsOpen(false)}>
          Careers
        </Link>
      </div>

      {/* Hamburger Icon */}
      <div className="hamburger" onClick={toggleMenu}>
        {isOpen ? "✕" : "☰"}
      </div>
    </nav>
  );
};

export default Navbar;
